var exports = {
  "h_": "middlePaneWrapper__2Ftc0v",
  "Ks": "labelListWrapper__FTmXVJ",
  "gC": "labelRowDescriptionItemDescription__btj1EZ",
  "iD": "labelRowIssuesAndPrsCount__zLwVeZ",
  "Ly": "labelRowDescription__BiyOt7",
  "Ie": "empty__sb_fTh",
  "jv": "noActionBar__KOpcUp",
  "ms": "loadingIssueAndPullRequestCount__5dHalt",
  "g4": "loadingContainer__S3vsWT",
  "wx": "header__xX7Zie",
  "i8": "titleGroup__Hcipui",
  "R_": "heading__kNQksf",
  "Fp": "dialogForm__LZ8Zbn",
  "N3": "dialogFormBody__EowscS",
  "_d": "dialogFormButtonGroup__REfwVl",
  "TH": "dialogFormInput__EUZrkO",
  "mA": "dialogFormPreviewContainer__K2uT2M",
  "d1": "countContainer__EFeXzU",
  "n_": "countItem__vYhvTp",
  "se": "archiveDialogFooter__B_mLgL",
  "Qk": "archiveDialogDismissal__Et_z3H",
  "GK": "archiveDialogActions__pO5jMD",
};

module.exports = exports;
